/**
 * The multi-game spine: every route, contract and (later) table row carries a `Game`.
 * Skill names are game terms — kept in English like item names; UI copy stays in i18n.
 */

export const GAMES = ['rs3', 'osrs'] as const

export type Game = (typeof GAMES)[number]

export function isGame(value: string | undefined): value is Game {
  return value !== undefined && (GAMES as readonly string[]).includes(value)
}

export interface GameMeta {
  name: string
  shortName: string
  /** Runic glyph used as the game's mark in chrome. */
  rune: string
  /** False while the game's adapters aren't wired (sections show "em breve"). */
  available: boolean
}

export const GAME_META: Record<Game, GameMeta> = {
  rs3: { name: 'RuneScape 3', shortName: 'RS3', rune: 'ᚱ', available: true },
  osrs: { name: 'Old School RuneScape', shortName: 'OSRS', rune: 'ᛟ', available: false },
}

/** Hiscores order. RS3 ends at Necromancy (29); OSRS has the classic 23. */
export const SKILLS: Record<Game, readonly string[]> = {
  rs3: [
    'Attack',
    'Defence',
    'Strength',
    'Constitution',
    'Ranged',
    'Prayer',
    'Magic',
    'Cooking',
    'Woodcutting',
    'Fletching',
    'Fishing',
    'Firemaking',
    'Crafting',
    'Smithing',
    'Mining',
    'Herblore',
    'Agility',
    'Thieving',
    'Slayer',
    'Farming',
    'Runecrafting',
    'Hunter',
    'Construction',
    'Summoning',
    'Dungeoneering',
    'Divination',
    'Invention',
    'Archaeology',
    'Necromancy',
  ],
  osrs: [
    'Attack',
    'Defence',
    'Strength',
    'Hitpoints',
    'Ranged',
    'Prayer',
    'Magic',
    'Cooking',
    'Woodcutting',
    'Fletching',
    'Fishing',
    'Firemaking',
    'Crafting',
    'Smithing',
    'Mining',
    'Herblore',
    'Agility',
    'Thieving',
    'Slayer',
    'Farming',
    'Runecrafting',
    'Hunter',
    'Construction',
  ],
}
